function isMoblieDevice() {
  if (navigator && navigator.userAgent && navigator.userAgent !== null) {
    var ua = navigator.userAgent.toLowerCase();
    return !!ua.match(
      /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i
    );
  }
  return false;
}
function debounce(funct, wait) {
  var timeout;
  return function () {
    var context = this;
    var args = arguments;
    var later = function () {
      timeout = null;
      funct.apply(context, args);
    };
    var callNow = !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      funct.apply(context, args);
    }
  };
}
function setFullwindowModeState(isEnabled) {
  var items = document.querySelectorAll(
    ".cc-mockup-container, .cc-top-bar-wrapper, .cc-editor-container"
  );
  for (var i = 0; i < items.length; ++i) {
    var item = items[i];
    if (isEnabled) {
      item.classList.add("cc-fullscreen-mode");
    } else {
      item.classList.remove("cc-fullscreen-mode");
    }
  }
  if (!isEnabled) {
    var topBar = document.querySelector(".cc-top-bar-wrapper");
    topBar.style.display = "none";
    topBar.offsetHeight;
    topBar.style.display = "flex";
  }
}
function isInPortraitMode() {
  return window.innerHeight > window.innerWidth;
}
function mobileToolbarWorkaround(editor) {
  if (!isMoblieDevice()) {
    return;
  }
  var isModalOpen = false;
  var screenWidth = window.screen.availWidth;
  var screenHeight = window.screen.availHeight;
  var toolbarHeight = 0;
  var editorContainer = document.querySelector(".cc-editor-container");
  var fitSize = debounce(function () {
    var width = window.innerWidth;
    var height = window.innerHeight;
    var isKeybarodVisible = 0.8 * screenHeight;
    if (isModalOpen && height < isKeybarodVisible) {
      height = screenHeight - toolbarHeight;
    }
    editorContainer.style.width = width + "px";
    editorContainer.style.maxWidth = width + "px";
    editorContainer.style.minWidth = width + "px";
    editorContainer.style.height = height + "px";
    editorContainer.style.maxHeight = height + "px";
    editorContainer.style.minHeight = height + "px";
    if (!isModalOpen) {
      if (!document.querySelector("w-product-template")) {
        window.scrollTo(0, 0);
      }
    }
  }, 350);
  editor.subscribe("ModalOpen", function () {
    isModalOpen = true;
    setFullwindowModeState(true);
    fitSize();
  });
  editor.subscribe("ModalClose", function () {
    isModalOpen = false;
    setFullwindowModeState(false);
    fitSize();
  });
  window.onorientationchange = function () {
    screenWidth = window.screen.availWidth;
    screenHeight = window.screen.availHeight;
    fitSize();
  };
  setTimeout(function () {
    toolbarHeight = screenHeight - window.innerHeight;
    if (!document.querySelector("w-product-template")) {
      window.onscroll = fitSize;
    }
    window.onresize = function () {
      fitSize();
    };

    if (!document.querySelector("w-product-template")) {
      window.scrollTo(0, 1);
    }
  }, 500);
}
function init1001cEditor(editorElementId, product, config, settings) {
  var onClickSaveButton = settings.onClickSaveButton;
  var onClickOrderButton = settings.onClickOrderButton;
  var $orderButton = document.getElementById("ccOrderButton");
  if ($orderButton) {
    $orderButton.addEventListener("click", onClickOrderButton, false);
  }
  var $historyUndoBtn = document.getElementById("ccHistoryUndo");
  var $historyRedoBtn = document.getElementById("ccHistoryRedo");
  var $saveBtn = document.getElementById("ccSaveButton");
  var iframe = document.getElementById(editorElementId);
  var editor = null;
  console.log(iframe, product, config);
  return CustomersCanvas.IframeApi.loadEditor(
    iframe,
    product,
    config,
    function () {}
  )
    .then(function (_e) {
      console.log(_e);
      editor = _e;
      console.log(editor);
      if ($historyUndoBtn) {
        $historyUndoBtn.addEventListener(
          "click",
          function () {
            editor.undo().then(function () {
              if (settings.onUndo) settings.onUndo();
            });
          },
          false
        );
      }
      if ($historyUndoBtn) {
        editor.subscribe("CanUndoChanged", function (value) {
          $historyUndoBtn.disabled = !value;
        });
      }
      if ($historyRedoBtn) {
        $historyRedoBtn.addEventListener(
          "click",
          function () {
            editor.redo().then(function () {
              if (settings.onRedo) settings.onRedo();
            });
          },
          false
        );
      }
      editor.subscribe("CanRedoChanged", function (value) {
        if ($historyRedoBtn) {
          $historyRedoBtn.disabled = !value;
        }
      });
      if ($saveBtn) {
        $saveBtn.addEventListener(
          "click",
          async function () {
            LoadMask.maskMessage(
              iframe.parentElement,
              "Enregistrement en cours..."
            );
            if (typeof product == "string" && product.length > 0) {
              await editor.saveProduct(product).then(onClickSaveButton);
            } else {
              await editor.saveProduct().then(onClickSaveButton);
            }
          },
          false
        );
      }
      imageMaxHeight = jQuery(iframe).height() - 140;
      return editor;
    })
    .catch((error) => {
      console.log("error");
      console.log(error);
    });
}
var LoadMask;
(function (LoadMask) {
  var loadMaskCssUrl;
  function maskElement(element) {
    if (isMaskedElement(element)) {
      unmaskElement(element);
    }
    //ensureStyleSheet();
    element?.classList.add("masked-element");
    var maskElementDiv = document.createElement("div");
    maskElementDiv.classList.add("mask");
    maskElementDiv.innerHTML = `
      <div class='loader-wraper'>
        <div class='cc-bars-loader' aria-hidden='true'>
          <div class='cc-bars-loader__bar'></div>
          <div class='cc-bars-loader__bar'></div>
          <div class='cc-bars-loader__bar'></div>
        </div>
        <div class='masked-element-message'></div>
      </div>
    `;
    prependChild(element, maskElementDiv);
  }
  LoadMask.maskElement = maskElement;
  function maskMessage(element, message, isError) {
    if (isError === void 0) {
      isError = false;
    }
    if (!isMaskedElement(element)) {
      maskElement(element);
    }
    if (element) {
      element.querySelector(".masked-element-message").innerText = message;
      if (isError) {
        element.querySelector(".mask").classList.add("warning");
      } else {
        element.querySelector(".mask").classList.remove("warning");
      }
    }
  }
  LoadMask.maskMessage = maskMessage;
  function unmaskElement(element) {
    element.classList.remove("masked-element");
    var maskElements = element.querySelectorAll(".mask");
    for (var i = 0; i < maskElements.length; i++) {
      element.removeChild(maskElements.item(i));
    }
  }
  LoadMask.unmaskElement = unmaskElement;
  function isMaskedElement(element) {
    return element?.classList.contains("masked-element");
  }
  LoadMask.isMaskedElement = isMaskedElement;
  function setCssUrl(url) {
    loadMaskCssUrl = url;
  }
  LoadMask.setCssUrl = setCssUrl;
  function ensureStyleSheet() {
    if (document.getElementById("cc-loadmask") != null) return;
    var link = document.createElement("link");
    link.type = "text/css";
    link.rel = "stylesheet";
    link.id = "cc-loadmask";
    LoadMask.setCssUrl();
    if (loadMaskCssUrl == null) {
      throw "loadMaskCssUrl must be defined, ensure that setCssUrl was called";
    } else {
      link.href = loadMaskCssUrl + "LoadMask.less";
    }
    prependChild(document.head, link);
  }
  function prependChild(rootElement, childElement) {
    rootElement?.insertBefore(childElement, rootElement.firstChild);
  }
})(LoadMask || (LoadMask = {}));

// Normalize the legacy CC SDK loader markup (.loader-wraper.icon-cc-logo with a
// round .loader + svg.logo) into our 3-bars .cc-bars-loader. The SDK injects
// the legacy markup whenever it shows its own LoadMask, bypassing ours; this
// observer rewrites it the moment it appears so the user always sees 3 bars.
(function () {
  var BARS_HTML =
    "<div class='cc-bars-loader' aria-hidden='true'>" +
    "<div class='cc-bars-loader__bar'></div>" +
    "<div class='cc-bars-loader__bar'></div>" +
    "<div class='cc-bars-loader__bar'></div>" +
    "</div>";
  function normalize(root) {
    if (!root) return;
    var nodes =
      root.nodeType === 1 && root.matches && root.matches(".loader-wraper.icon-cc-logo")
        ? [root]
        : root.querySelectorAll
        ? root.querySelectorAll(".loader-wraper.icon-cc-logo")
        : [];
    for (var i = 0; i < nodes.length; i++) {
      var w = nodes[i];
      w.classList.remove("icon-cc-logo");
      w.innerHTML = BARS_HTML;
    }
  }
  function start() {
    normalize(document.body);
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) normalize(added[j]);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();

// Lightweight loader that covers ONLY the editor iframe (not full viewport).
// Used for short operations like paper/cut change so the user keeps seeing the
// rest of the page (drawers, header, options bar). Falls back to no-op if iframe
// missing.
var IframeLoader;
(function (IframeLoader) {
  function show(message) {
    var iframe = document.getElementById('editorFrame');
    if (!iframe) return null;
    var rect = iframe.getBoundingClientRect();
    var overlay = document.createElement('div');
    overlay.className = 'cc-iframe-loader';
    overlay.style.cssText =
      'position:fixed;' +
      'top:' + rect.top + 'px;' +
      'left:' + rect.left + 'px;' +
      'width:' + rect.width + 'px;' +
      'height:' + rect.height + 'px;' +
      'background:rgba(255,255,255,0.7);' +
      'backdrop-filter:blur(2px);' +
      '-webkit-backdrop-filter:blur(2px);' +
      'z-index:50;' +
      'display:flex;' +
      'align-items:center;' +
      'justify-content:center;' +
      'flex-direction:column;' +
      'pointer-events:auto;';
    overlay.innerHTML =
      "<div class='cc-bars-loader' aria-hidden='true'>" +
      "<div class='cc-bars-loader__bar'></div>" +
      "<div class='cc-bars-loader__bar'></div>" +
      "<div class='cc-bars-loader__bar'></div>" +
      "</div>" +
      (message
        ? "<div style='margin-top:16px;text-align:center;font-size:18px;font-weight:500;line-height:24px;color:#666666;font-family:Roboto,Helvetica,Arial,sans-serif;'>" + message + "</div>"
        : "");
    document.body.appendChild(overlay);
    return overlay;
  }
  function hide(overlay) {
    if (overlay && overlay.parentNode) {
      overlay.parentNode.removeChild(overlay);
    }
  }
  IframeLoader.show = show;
  IframeLoader.hide = hide;
})(IframeLoader || (IframeLoader = {}));
window.IframeLoader = IframeLoader;

function notify(message, type) {
  new Noty({
    type: type ? type : "success",
    text: message,
    timeout: 3000,
    modal: true,
    layout: "center",
  }).show();
}
